var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFont = function SvgFont(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.013 7.87V6.701h-1.169a.706.706 0 0 1-.7-.701c0-.383.317-.701.7-.701h1.17v-1.17c0-.383.317-.7.7-.7.384 0 .702.317.702.7V5.3h1.169c.383 0 .7.318.7.7a.706.706 0 0 1-.7.702h-1.17V7.87a.706.706 0 0 1-.7.701.706.706 0 0 1-.702-.701M4.433 0H6.71l4.433 12H8.69L7.674 8.96H3.329L2.313 12H0zm2.61 7.088-1.542-4.66-1.559 4.66z"
  })));
};
export default SvgFont;